import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { UserTestimonialsInterface } from 'ks-common';
import { Card } from 'app/components/StaticPages';
import Stars from './Stars';

interface Props {
  testimonial: UserTestimonialsInterface;
}

const TestimonialCard: FC<Props> = ({ testimonial }) => (
  <Card
    sx={{
      p: { xs: 3, md: 4 },
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Typography variant="h3" sx={{ mb: 0.5, color: 'staticPages.navy' }}>
      {testimonial.Subject}
    </Typography>
    <Typography
      variant="body2"
      sx={{ mb: 2, color: 'staticPages.text.light', fontWeight: 500 }}
    >
      {testimonial.Name}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        mb: 2.5,
        lineHeight: 1.7,
        color: 'staticPages.text.secondary',
        flex: 1,
      }}
    >
      {testimonial.Body}
    </Typography>
    <Stars stars={testimonial.Stars} />
  </Card>
);

export default TestimonialCard;
